export default "__VITE_ASSET__TRDi5uMz__"